import React from 'react';
import { motion } from 'framer-motion';
const photos = [{
  src: 'https://cdn.magicpatterns.com/uploads/9iUbMW7EXRNfa4RJsoELHD/16-9-fullframe-export_(0;00;41;00)_molo.jpg',
  alt: 'Marina při západu slunce',
  caption: 'Marina · ráno před startem',
  span: 'md:col-span-2 md:row-span-2',
  aspect: 'aspect-[16/10]'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mVDLYHkJDEjdFbcn2ZjTWE/16-9-fullframe-export_(0;01;31;28)_detIII.jpg',
  alt: 'Detail kladky a lan',
  caption: 'Takeláž · detail',
  span: '',
  aspect: 'aspect-[4/3]'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9xtP2ahJTe57vkbeYt22Az/16-9-fullframe-export_(0;01;32;27)_detII.jpg',
  alt: 'Detail kladky na ráhně',
  caption: 'Kotvení · detail',
  span: '',
  aspect: 'aspect-[4/3]'
}];
export function Gallery() {
  return <section id="galerie" className="w-full bg-white py-24 px-6 scroll-mt-20" data-id="element-125" data-mp="26v83sj1mvm4q">
      <div className="max-w-6xl mx-auto" data-id="element-126" data-mp="21x6jjush1gro">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16 max-w-2xl" data-id="element-127" data-mp="rckqlcbzo0cv">
          <p className="text-sm uppercase tracking-[0.2em] text-blue-medium mb-3 font-medium" data-id="element-128" data-mp="152o6llk9yxtv">
            Atmosféra
          </p>
          <h2 className="text-[48px] font-[200] text-navy-deep mb-4" data-id="element-129" data-mp="8fry3ianb3jl">
            Detaily, které tvoří plavbu
          </h2>
          <p className="text-navy-deep/70 leading-relaxed" data-id="element-130" data-mp="hedf390gyai9">
            Ranní ticho v maríně, napětí v lanech, dřevo paluby zalité sluncem.
            Future Challenge je o detailech, které si pamatujete dlouho po
            návratu do přístavu.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-131" data-mp="1svwk96xm0njg">
          {photos.map((photo, i) => <motion.figure key={photo.src} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: i * 0.1
        }} className={`group relative overflow-hidden rounded-xl shadow-sm ${photo.span}`} data-id="element-132" data-mp="3tvrtpfg349hj" data-mpi={i}>
              <div className={`${photo.aspect} overflow-hidden`} data-id="element-133" data-mp="3680ea2z8zgc1">
                <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-134" data-mp="3kw4yjbdy7zwx" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-135" data-mp="2scplcv4kd5ab" />
              <figcaption className="absolute bottom-4 left-4 right-4 text-white text-sm font-serif-italic opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-136" data-mp="12w3xf67mrux9">
                {photo.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}